import { render, staticRenderFns } from "./ScenarioPropertiesList.vue?vue&type=template&id=56773f23&scoped=true&"
import script from "./ScenarioPropertiesList.vue?vue&type=script&lang=ts&"
export * from "./ScenarioPropertiesList.vue?vue&type=script&lang=ts&"
import style0 from "./ScenarioPropertiesList.vue?vue&type=style&index=0&id=56773f23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56773f23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
